import Vue from 'vue';
import Router from 'vue-router';
import index from '@/components/index';
import about from '@/components/about';
import news from '@/components/news';
import cybercorner from '@/components/cyber-corner.vue';
import blog from '@/components/blog';
import blogdetail from '@/components/blogdetail';
import blogArchives from '@/components/blogArchives';
import newsdetail from '@/components/newsdetail';
import newsArchives from '@/components/newsArchive.vue';
import community from '@/components/community';
import dashboard from '@/components/dashboard';
import myaccount from '@/components/my-account';
import pilotregister from '@/components/resource/pilot-register';
import pilotregisterconference from '@/components/resource/pilot-register-for-conference-members';
import mepregister from '@/components/resource/mep-register';
import contact from '@/components/contact';
import error from '@/components/error';
import verify from '@/components/verify';
import verifymfa from '@/components/verify-mfa';
import newpassword from '@/components/new-password';
import verifyphone from '@/components/verify-phone';
import login from '@/components/login';
import logout from '@/components/logout';
import signup from '@/components/signup';
import clientTemplates from '@/components/resource/client-templates.vue';
import clientTemplateItem from '@/components/resource/client-template-item.vue';
import cyberreadinesscheck from '@/components/resource/cyber-readiness-check';
import cyberreadinesschecktool from '@/components/resource/cyber-readiness-check-tool';
import cyberreadinesschecktraining from '@/components/resource/cyber-readiness-check-training';
import toollist from '@/components/resource/tool-list';
import tooldetails from '@/components/resource/tool-details';
import toolcompare from '@/components/resource/tool-compare';
import whitepapers from '@/components/resource/white-papers';
import whitePapersArchives from '@/components/resource/white-papers-archives.vue';
import whitepaperdetail from '@/components/resource/white-paper-detail';
import cybercircuitsdetail from '@/components/resource/cyber-circuits-detail';
import eventdetail from '@/components/resource/event-detail';
import events from '@/components/resource/events';
import aboutcmmc from '@/components/resource/about-cmmc';
import onlinecourses from '@/components/resource/online-courses';
import trainingvideos from '@/components/resource/training-videos';
import coursesencite from '@/components/courses-encite';
import coursesencitebb from '@/components/courses-encitebb';
import coursesencitefoci from '@/components/courses-encitefoci';
import coursesOnline from '@/components/courses-online.vue';
import pilotprogram from '@/components/resource/pilot-programs';
import sba from '@/components/resource/small-business-administration';
import partners from '@/components/resource/partners-landing';
import pricing from '@/components/pricing';
import speakerrequest from '@/components/speaker-request';
import policycorner from '@/components/policycorner';
import policyCornerInfo from '@/components/policyCornerInfo.vue'
import mep from '@/components/resource/manufacturing-extension-partnership';
import usefullinks from '@/components/resource/useful-links';
import livestream from '@/components/resource/live-stream';
import pillarsOfKnowledge from '@/components/pillars-of-knowledge';
import informationVideos from '@/components/information-videos';
import store from '@/store';
import axios from 'axios';
import { } from '@/utils/authentication';
import {
  isLoggedIn,
  getAreAccountRequiredFieldsFilled,
} from '../utils/authentication';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (to.path !== from.path) {
      return new Promise((resolve) => {
        Vue.nextTick(() => {
          resolve({ x: 0, y: 0, behavior: 'smooth' });
        });
      });
    }
  },
  routes: [
    {
      // /search/screens -> /search?q=screens
      path: '/!',
      redirect: to => {
        // the function receives the target route as the argument
        // we return a redirect path/location here.
        return { path: '/' }
      }
    },
    {
      // /search/screens -> /search?q=screens
      path: '/#!/register',
      redirect: to => {
        // the function receives the target route as the argument
        // we return a redirect path/location here.
        return { path: '/signup' }
      }
    },
    {
      // /search/screens -> /search?q=screens
      path: '/!/register',
      redirect: to => {
        // the function receives the target route as the argument
        // we return a redirect path/location here.
        return { path: '/signup' }
      }
    },
    {
      // /search/screens -> /search?q=screens
      path: '/#!/eventRegistration/:id',
      redirect: to => {
        // the function receives the target route as the argument
        // we return a redirect path/location here.
        return { path: '/event-detail', query: { id: to.params.id } }
      }
    },
    {
      // /search/screens -> /search?q=screens
      path: '/!/eventRegistration/:id',
      redirect: to => {
        // the function receives the target route as the argument
        // we return a redirect path/location here.
        return { path: '/event-detail', query: { id: to.params.id } }
      },
    },
    {
      // /search/screens -> /search?q=screens
      path: '/!/blog/blog-post/:id',
      redirect: to => {
        // the function receives the target route as the argument
        // we return a redirect path/location here.
        return { path: '/blogdetail', query: { id: to.params.id } }
      },
    },
    {
      path: '/',
      name: 'index',
      component: index,
    },
    {
      path: '/about',
      name: 'about',
      component: about,
    },
    {
      path: '/default/dashboard/organization',
      name: 'dashboard',
      component: dashboard,
    },
    {
      path: '/news',
      name: 'news',
      component: news,
      props: (route) => ({ query: route.query.query, newsPage: route.query.newsPage }),
    },
    {
      path: '/newsArchives',
      name: 'newsArchives',
      component: newsArchives,
      props: (route) => ({ query: route.query.query, newsPage: route.query.newsPage }),
    },
    {
      path: '/community',
      name: 'community',
      component: community,
    },
    {
      path: '/cyber-corner',
      name: 'cybercorner',
      component: cybercorner,
    },
    {
      path: '/blog',
      name: 'blog',
      component: blog,
      props: (route) => ({ query: route.query.query, blogPage: route.query.blogPage }),
    },
    {
      path: '/blogArchives',
      name: 'blogArchives',
      component: blogArchives,
      props: (route) => ({ query: route.query.query, blogPage: route.query.blogPage }),
    },
    {
      path: '/blogdetail',
      name: 'blogdetail',
      component: blogdetail,
      props: (route) => ({ id: route.query.id, blogPage: route.query.blogPage, query: route.query.query, isRecentBlogs: route.query.isRecentBlogs }),
    },
    {
      path: '/newsdetail',
      name: 'newsdetail',
      component: newsdetail,
      props: (route) => ({ id: route.query.id, newsPage: route.query.newsPage, query: route.query.query, isRecentNews: route.query.isRecentNews }),
    },
    {
      path: '/verify',
      name: 'verify',
      component: verify,
      props: (route) => ({ email: route.query.email, message: route.query.message, accountType: route.query.accountType, redirect: route.query.redirect }),
    },
    {
      path: '/verify-mfa',
      name: 'verify-mfa',
      component: verifymfa,
      props: (route) => ({
        session: route.query.session,
        username: route.query.username,
        redirect: route.query.redirect,
      }),
    },
    {
      path: '/new-password',
      name: 'new-password',
      component: newpassword,
      props: (route) => ({
        session: route.query.session,
        username: route.query.username,
        redirect: route.query.redirect,
      }),
    },
    {
      path: '/verify-phone',
      name: 'verify-phone',
      component: verifyphone,
      props: (route) => ({ phone: route.query.phone }),
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      props: (route) => ({ redirect: route.query.redirect, queryString: route.query.queryString, queryValue: route.query.queryValue }),
    },
    {
      path: '/logout',
      name: 'logout',
      component: logout,
    },
    {
      path: '/signup',
      name: 'signup',
      component: signup,
      props: (route) => ({ redirect: route.query.redirect }),
    },
    {
      path: '/my-account',
      name: 'my-account',
      component: myaccount,
    },
    {
      path: '/pilot-register',
      name: 'pilot-register',
      component: pilotregister,
    },
    {
      path: '/pilot-conference-register',
      name: 'pilot-register-conference',
      component: pilotregisterconference,
    },
    {
      path: '/mep-register',
      name: 'mep-register',
      component: mepregister,
    },
    // {
    //   path: '/contact',
    //   name: 'contact',
    //   component: contact,
    // },
    {
      path: '/speaker-request',
      name: 'speakerrequest',
      component: speakerrequest,
    },
    {
      path: '/cyber-readiness-check',
      name: 'cyber-readiness-check',
      component: cyberreadinesscheck,
      props: true,
    },
    {
      path: '/live-stream',
      name: 'live-stream',
      component: livestream,
      props: true,
    },
    {
      path: '/cyber-readiness-check-tool/:toolKey',
      name: 'cyber-readiness-check-tool',
      component: cyberreadinesschecktool,
      props: (route) => ({ query: route.query.query }),
    },
    // {
    //   path: '/cyber-readiness-check-training',
    //   name: 'cyber-readiness-check-training',
    //   component: cyberreadinesschecktraining
    // },
    {
      path: '/tool-list',
      name: 'tool-list',
      component: toollist,
    },
    {
      path: '/tool-details',
      name: 'tool-details',
      component: tooldetails,
      props: (route) => ({ id: route.query.id }),
    },
    {
      path: '/tool-compare',
      name: 'tool-compare',
      component: toolcompare,
      props: (route) => ({ ids: route.query.ids }),
    },
    {
      path: '/white-papers',
      name: 'white-papers',
      component: whitepapers,
      props: (route) => ({ query: route.query.query, paperPage: route.query.paperPage }),
    },
    {
      path: '/white-papers-archives',
      name: 'white-papers-archives',
      component: whitePapersArchives,
      props: (route) => ({ query: route.query.query, paperPage: route.query.paperPage })
    },
    // {
    //   path: '/white-paper-detail',
    //   name: 'white-paper-detail',
    //   component: whitepaperdetail,
    //   props: (route) => ({ id: route.query.id, query: route.query.query, paperPage: route.query.paperPage, isRecentPapers: route.query.isRecentPapers }),
    // },
    {
      path: '/events',
      name: 'events',
      component: events,
      props: (route) => ({ query: route.query.query, eventPage: route.query.eventPage, eventType: route.query.eventType, eventsArchived: route.query.eventsArchived }),
    },
    {
      path: '/cyber-circuits-detail',
      name: 'cyber-circuits-detail',
      component: cybercircuitsdetail,
      props: (route) => ({ id: route.query.id, eventPage: route.query.eventPage, query: route.query.query, eventType: route.query.eventType }),
    },
    {
      path: '/event-detail',
      name: 'event-detail',
      component: eventdetail,
      props: (route) => ({ id: route.query.id, eventPage: route.query.eventPage, query: route.query.query, eventType: route.query.eventType, isEventArchived: route.query.isEventArchived }),
    },
    // {
    //   path: '/about-cmmc',
    //   name: 'about-cmmc',
    //   component: aboutcmmc,
    // },
    // {
    //   path: '/online-courses',
    //   name: 'online-courses',
    //   component: onlinecourses,
    // },
    {
      path: '/training-videos',
      name: 'training-videos',
      component: trainingvideos,
      props: (route) => ({ query: route.query.query }),
    },
    {
      path: '/courses-encite',
      name: 'courses-encite',
      component: coursesencite,
      props: (route) => ({ query: route.query.query }),
    },
    {
      path: '/courses-encitefoci',
      name: 'courses-encitefoci',
      component: coursesencitefoci,
      props: (route) => ({ query: route.query.query }),
    },
    {
      path: '/courses-encitebb',
      name: 'courses-encitebb',
      component: coursesencitebb,
      props: (route) => ({ query: route.query.query }),
    },
    {
      path: '/online-courses',
      name: 'online-courses',
      component: coursesOnline,
    },
    // {
    //   path: '/pilot-program',
    //   name: 'pilot-program',
    //   component: pilotprogram,
    // },
    // {
    //   path: '/small-business-administration',
    //   name: 'small-business-administration',
    //   component: sba,
    // },
    // {
    //   path: '/partners',
    //   name: 'partners',
    //   component: partners,
    // },
    // {
    //   path: '/mep',
    //   name: 'mep',
    //   component: mep,
    // },
    {
      path: '/useful-links',
      name: 'useful-links',
      component: usefullinks,
      props: (route) => ({ query: route.query.query }),
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: pricing
    },
    {
      path: '/policy-corner',
      name: 'policy-corner',
      component: policycorner
    },
    {
      path: '/policy-corner-info',
      name: 'policy-corner-info',
      component: policyCornerInfo,
      props: (route) => ({ policyCode: route.query.policyCode })
    },
    // {
    //   path: '/pillars-of-knowledge',
    //   name: 'pillars-of-knowledge',
    //   component: pillarsOfKnowledge,
    // },
    {
      path: '/information-videos',
      name: 'information-videos',
      component: informationVideos,
    },
    {
      path: '/client-templates',
      name: 'client-templates',
      component: clientTemplates,
    },
    {
      path: '/client-template-item',
      name: 'client-template-item',
      component: clientTemplateItem,
      props: (route) => ({ templateId: route.query.templateId }),
    },
    {
      path: '/',
      name: 'index',
      component: index,
      props: (route) => ({ selectedSegment: route.query.segment })
    },
    {
      path: '*',
      name: 'error',
      component: error,
    },
  ],
});

router.beforeResolve(async (to, from, next) => {
  
  if (isLoggedIn()) {
    /** Track User Activity */
    axios
      .post('/api/spectranalytics/authenticated', {
        event: 'url',
        description: to.fullPath,
      })
      .then(() => {
        console.log('Tracked User Activity');
      })
      .catch((error) => {
        handleApiError(error, null);
      });

    /** Redirect to Account Details if required fields are missing */
    const pagesNotRequiringFilledFields = ['/my-account', '/logout'];
    if (
      !getAreAccountRequiredFieldsFilled() &&
      !pagesNotRequiringFilledFields.includes(to.fullPath)
    ) {
      next('/my-account');
    }
  } else {
    /** Track Anonymous Activity */
    axios
      .post('/api/spectranalytics/anonymous', {
        event: 'url',
        description: to.fullPath,
      })
      .then(() => {
        console.log('Tracked Anonymous Activity');
      })
      .catch((error) => {
        console.log(error);
      });
  }
  return next();
});

//  Use this function to generate dynamical route list for sitemap.
// function getRoutesList(routes, pre) {
//    const routesList =  routes.reduce((array, route) => {
//       const path = `${pre}${route.path}`;

//       if (route.path !== '*') {
//         array.push(path);
//       }

//       if (route.children) {
//         array.push(...getRoutesList(route.children, `${path}/`));
//       }

//       return array;
//     }, []);
//     //console.log(routesList);
// }
// getRoutesList(router.options.routes, '');

export default router;
